import axios from "axios";
import {
  FETCH_PROMOCIONES_REQUEST,
  FETCH_PROMOCIONES_SUCCESS,
  FETCH_PROMOCIONES_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionPromocionesGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_PROMOCIONES_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/promociones", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_PROMOCIONES_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar promociones";
    dispatch({ type: FETCH_PROMOCIONES_FAILURE, payload: { error: msg } });
  }
};

export const apiPromocionesInstance = api;
export { authHeader as authHeaderPromociones };
